import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState({
    currentUser: (state) => state.currentUser,
    currentAgency: (state) => state.currentAgency
  }),
  ...mapGetters('auth', ['loggedIn', 'inAgency', 'currentUser', 'currentAgency']),
}

export const authMethods = mapActions('auth', ['logIn', 'setAgency', 'setUser', 'logOut', 'loginRedirect', 'loginCheck'])

export const moneyFormat = {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  precision: 2,
  masked: false
}

export const editorConfig = {
  placeholder: '',
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'font': [] }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ]
  }
}

export const editorConfigWithoutBar = {
  "theme": "snow",
  "placeholder": '',
  "modules": {
      "toolbar": false
  }
};
